import {
  Mtds,
  useGetSampleTakingReportQuery,
  type SinglePlan
} from 'prove-common'
import { CumulativeChart } from '../statistics/CumulativeChart'
import { buildCumulativeCalendarSeries } from '../../utils/statisticsUtils'
import styles from './PlanStatisticsTab.module.css'

export const PlanStatisticsTab = ({ plan }: { plan: SinglePlan }) => {
  const year = plan.due
    ? new Date(plan.due).getUTCFullYear()
    : new Date().getFullYear()
  const report = useGetSampleTakingReportQuery({
    planId: plan.id,
    from: `${year}-01-01`,
    through: `${year}-12-31`
  })
  const monthlyRows = (report.data?.timeSeries ?? []).map((row, id) => ({
    id,
    month: new Date(`${row.period.from}T12:00:00`)
      .toLocaleString('nb-NO', { month: 'short' })
      .replace(/^./, (character) => character.toUpperCase()),
    samplesTaken: Number(row.measures.planExecution?.performedUnitCount ?? 0),
    samplesPlanned: Number(row.measures.planExecution?.plannedUnitCount ?? 0)
  }))
  const rows = buildCumulativeCalendarSeries(monthlyRows, { year })
  const hasData = rows.some(
    (row) => row.samplesTaken > 0 || row.samplesPlanned > 0
  )

  return (
    <Mtds.Grid data-gap='6'>
      <Mtds.Heading as='h2' data-size='sm'>
        Statistikk
      </Mtds.Heading>
      <Mtds.Card>
        <Mtds.Grid data-gap='6'>
          <Mtds.Heading as='h3' data-size='xs'>
            Akkumulert uttak ({year})
          </Mtds.Heading>
          {report.isPending ? (
            <p role='status'>Laster statistikk …</p>
          ) : report.isError ? (
            <Mtds.Alert data-color='danger'>
              Kunne ikke hente statistikk.
            </Mtds.Alert>
          ) : !hasData ? (
            <p>Ingen planlagte eller registrerte uttak i {year}.</p>
          ) : (
            <div
              className={styles.viewport}
              role='region'
              aria-label='Akkumulert uttak per måned'
              tabIndex={0}
            >
              <CumulativeChart
                rows={rows}
                year={year}
                plannedEndpoint={report.data?.plannedEndpoint}
              />
            </div>
          )}
        </Mtds.Grid>
      </Mtds.Card>
    </Mtds.Grid>
  )
}
